import { ReactWebComponent } from '@app/utils/web-components';
import { lazy } from 'react';

const UserGroupAddProjectToaster = lazy(() => import('./UserGroupAddProjectToaster'));

/**
 * This is a dirty hack to use some shared react components in the team project modal.
 * I don't have the time to untangle the jQuery code that drives this form, so for now
 * I am going to get in where it's easiest, use the shared component, and throw the job back into jQuery.
 * I don't like it either, but it's the fastest I could think of way to get this done.
 */
class AddProjectToasterWebComponent extends ReactWebComponent {
    render() {
        return <UserGroupAddProjectToaster />;
    }
}

customElements.define('user-group-add-project-toaster', AddProjectToasterWebComponent);
